export const DAY_KEYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const DAY_LABELS_HU = {
  sunday: 'VAS',
  monday: 'HÉTFŐ',
  tuesday: 'KEDD',
  wednesday: 'SZERDA',
  thursday: 'CSÜTÖRTÖK',
  friday: 'PÉNTEK',
  saturday: 'SZOMBAT',
};

export const MONTH_ABBREV_HU = [
  'JAN.',
  'FEB.',
  'MÁR.',
  'ÁPR.',
  'MÁJ.',
  'JÚN.',
  'JÚL.',
  'AUG.',
  'SZEPT.',
  'OKT.',
  'NOV.',
  'DEC.',
];

export const PLACEHOLDER_ROWS = [
  {
    title: 'Zöldségleves',
    sides: 'Grízes tészta, kompót',
    icon: '🍲',
  },
  {
    title: 'Rántott csirkemell',
    sides: 'Burgonyapüré, savanyúság',
    icon: '🍗',
  },
  {
    title: 'Bolognai spagetti',
    sides: 'Reszelt sajt, friss saláta',
    icon: '🍝',
  },
];

const MEAL_ICONS = ['🍲', '🍗', '🍝', '🥗', '🍽️'];

export function getWeekDatesFromMonday(baseDate = new Date()) {
  const today = new Date(baseDate);
  const currentDay = today.getDay();
  const monday = new Date(today);
  monday.setHours(0, 0, 0, 0);
  monday.setDate(today.getDate() - currentDay + (currentDay === 0 ? -6 : 1));

  const weekDates = [];
  for (let i = 0; i < 7; i += 1) {
    const date = new Date(monday);
    date.setDate(monday.getDate() + i);
    weekDates.push(date);
  }
  return weekDates;
}

export function dayKeyForDate(date) {
  return DAY_KEYS[date.getDay()];
}

export function formatMealSubtitle(dayMeals) {
  if (!dayMeals || typeof dayMeals !== 'object') return '';
  const parts = [];
  if (dayMeals.dinner?.trim()) parts.push(dayMeals.dinner.trim());
  if (Array.isArray(dayMeals.snacks)) {
    dayMeals.snacks.filter(Boolean).forEach((s) => parts.push(String(s).trim()));
  }
  return parts.join(', ');
}

export function mealIconForTitle(title, index) {
  const t = (title || '').toLowerCase();
  if (/leves|gulyás|halászlé|krém/.test(t)) return '🍲';
  if (/csirke|hús|rántott|pecsenye|sült/.test(t)) return '🍗';
  if (/spagetti|tészta|makaróni|rizottó/.test(t)) return '🍝';
  return MEAL_ICONS[index % MEAL_ICONS.length];
}

export async function fetchCurrentWeekMenus(apiBase) {
  const year = new Date().getFullYear();
  const res = await fetch(`${apiBase}/menus?week=current&year=${year}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data.menus) ? data.menus : [];
}

export function pickPreviewMenu(menus) {
  if (!menus.length) return null;
  return (
    menus.find((m) => m.category === 'normal') ||
    menus.find((m) => m.pdfFile?.path || m.pdfFile?.filename) ||
    menus[0]
  );
}

function rowFromDateAndMeals(date, dayMeals, placeholderIndex) {
  const placeholder = PLACEHOLDER_ROWS[placeholderIndex % PLACEHOLDER_ROWS.length];
  const lunch = dayMeals?.lunch?.trim();
  const title = lunch || placeholder.title;
  const sides = lunch ? formatMealSubtitle(dayMeals) || placeholder.sides : placeholder.sides;

  return {
    date,
    dayLabel: DAY_LABELS_HU[dayKeyForDate(date)],
    dayNum: date.getDate(),
    monthAbbrev: MONTH_ABBREV_HU[date.getMonth()],
    title,
    sides: sides || '',
    icon: mealIconForTitle(title, placeholderIndex),
    isPlaceholder: !lunch,
  };
}

export function buildPreviewRows(menu, count = 3) {
  const weekDates = getWeekDatesFromMonday();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingDates = weekDates.filter((d) => {
    const copy = new Date(d);
    copy.setHours(0, 0, 0, 0);
    return copy >= today;
  });

  const sourceDates =
    upcomingDates.length >= count
      ? upcomingDates.slice(0, count)
      : [...upcomingDates, ...weekDates].slice(0, count);

  return sourceDates.map((date, index) => {
    const key = dayKeyForDate(date);
    const dayMeals = menu?.meals?.[key];
    return rowFromDateAndMeals(date, dayMeals, index);
  });
}
